import { GenericLazyString } from '@eventbrite/i18n';
import {
    DEFAULT_VALIDATION_ERROR,
    VALIDATION_ERRORS_MAP,
} from '../../containers/checkout/constants';

export const getErrorMessage = (field: string): GenericLazyString =>
    (VALIDATION_ERRORS_MAP as Record<string, GenericLazyString>)[field] ||
    DEFAULT_VALIDATION_ERROR;
